<template>
  <div>
    <!-- Page title -->
    <page-title icon="fas fa-clipboard" main="Plano de Metas Bayer">
      <base-button
        slot="actions"
        @click="modal0 = true"
        type="info"
        class="ml-3"
        size="sm"
        >Cadastrar</base-button
      >
    </page-title>
    <div class="card mt-2 pb-5" style="padding: 0rem 1rem">
      <div class="row">
        <div  class="col-lg-12 card-header">
          <h5 class="h3 mb-0">Participação Plano de Metas Bayer</h5>
          <h6 class="text-uppercase text-muted ls-1 mb-1">Configure quais dados deverão ser listados:  </h6>
        </div>
        <div class="col-md-3 mt-3 ">
          <label class="form-control-label">Cargo</label>
          <multiselect
            v-model="filter.category"
            :options="cargo"
            :select-label="''"
            :deselect-label="''"
            :selected-label="'Selecionado'"
            placeholder="Selecionar Cargo"
          ></multiselect>
        </div>
        <div class="col-md-3 mt-3 ">
          <label class="form-control-label">Periodo de Vigência</label>
          <multiselect
            v-model="partSearch"
            :options="participation"
            label="descricao"
            :select-label="''"
            :deselect-label="''"
            :selected-label="'Selecionado'"
            placeholder="Selecionar Período de Vigência"
          ></multiselect>
        </div>
        <div class="col-md-6 mt-5 ">
          <base-button icon type="info" @click="search">
            <span class="btn-inner--icon">
              <i class="fas fa-search"></i>
            </span>
            <span class="btn-inner--text"><strong>Pesquisar
              </strong></span>
          </base-button>
          <base-button
              type="secondary"
              class="mr-2"
              @click="clearFilters">
              Limpar Filtros
          </base-button>
        </div>
      </div>
      <modal :show.sync="modal0">
        <template slot="header">
          <h5 class="modal-title" id="exampleModalLabel">
            Cadastrar participação Plano de Metas Bayer
          </h5>
        </template>
        <form role="form" @submit.prevent="save">
          <div class="row justify-content-md-center">
            <div class="col-12 form-group">
              <label class="form-control-label"
                >Plano de Metas Bayer Vegetal</label
              ><br />
              <input
                type="checkbox"
                v-model="checkbox"
                class="checkboxtext"
                v-on:change="metaBayerCem"
                name="100"
              />
              <label for="100" class="labelCheck">100%</label>
            </div>
            <div class="col-6 form-group">
              <label class="form-control-label">Cargo</label><br />
              <multiselect
                v-model="cargoSelected"
                :options="cargo"
                :required="true"
                placeholder="Selecionar Cargo"
                :select-label="''"
                :deselect-label="''"
                :selected-label="'Selecionado'"
                :disabled="!checkbox"
              ></multiselect>
              <div v-if="errors && errors.category && errors.category.length" class="invalid-feedback" style="display: block;">
                {{ errors.category[0] }}
              </div>
            </div>
            <div class="col-6 form-group">
               <base-input
                label="Percentual de Participação"
                placeholder="Porcentagem"
                v-model="percentual"
                :required="true"
                type="number"
                :disabled="!checkbox"
                name="percentage"
                append-icon="fa fa-percent"
              />
            </div>
            <div class="col-6 form-group">
              <label class="form-control-label">Rebate</label><br />
              <input
                type="number"
                class="form-control"
                placeholder="Rebate"
                v-model="rebateValue"
                :required="true"
                aria-label="Valor rebate"
                :disabled="!checkbox"
              />
            </div>
            <div class="col-6 form-group">
              <label class="form-control-label">Período</label>
              <multiselect
                v-model="partSelected"
                :options="participation"
                label="descricao"
                :required="true"
                placeholder="Selecionar Período"
                :disabled="!checkbox"
                :select-label="''"
                :deselect-label="''"
                :selected-label="'Selecionado'"
              ></multiselect>
            </div>
          </div>
        </form>
        <template slot="footer">
          <base-button class="mr-2" type="secondary" @click="modal0 = false"
            >Fechar</base-button
          >
          <base-button type="info" @click="save">Salvar</base-button>
        </template>
      </modal>
      <modal :show.sync="modal1">
        <template slot="header">
          <h5 class="modal-title" id="exampleModalLabel">
            Atualizar participação Plano de Metas Bayer
          </h5>
        </template>
        <form role="form" @submit.prevent="editMetas">
          <div class="row justify-content-md-center">
            <div class="col-12 form-group">
              <label class="form-control-label"
                >Plano de Metas Bayer Vegetal</label
              ><br />
              <input
                type="checkbox"
                v-model="metas"
                class="checkboxtext"
                name="100"
                :disabled="true"
              />
              <label for="100" class="labelCheck">100%</label>
            </div>
            <div class="col-6 form-group">
              <label class="form-control-label">Cargo</label><br />
              <multiselect
                v-model="metas.human__category"
                :options="cargo"
                :disabled="true"
                :select-label="''"
                :deselect-label="''"
                :selected-label="'Selecionado'"
                placeholder="Selecionar Cargo"
              ></multiselect>
            </div>
            <div class="col-6">
              <label class="form-control-label"
                >Percentual de Participação</label
              ><br />
              <base-input
                mask="volume"
                placeholder="Selecionar Percentual"
                v-model="metas.percentage_partipation"
              />
            </div>
            <div class="col-6">
              <label class="form-control-label">Rebate</label><br />
              <base-input
                mask="volume"
                placeholder="Rebate"
                v-model="metas.rebate"
                aria-label="Valor rebate"
              />
            </div>
            <div class="col-6 form-group">
              <label class="form-control-label">Período</label>
              <multiselect
                v-model="metas.period"
                :options="participation"
                :disabled="true"
                :select-label="''"
                :deselect-label="''"
                :selected-label="'Selecionado'"
                placeholder="Selecionar Período"
              ></multiselect>
            </div>
          </div>
        </form>
        <template slot="footer">
          <base-button type="secondary" @click="modal1 = false"
            >Fechar</base-button
          >
          <base-button type="success" @click="editMetas">Atualizar</base-button>
        </template>
      </modal>
      <div class="tableStyle">
        <el-table
          v-loading= "isLoading"
          class="table-responsive table-striped"
          header-row-class-name="thead-light"
          :data="metasBayer"
          min-wid_typeth="500px"
        >
          <el-table-column
            label="Cargo"
            prop="is_coordinator"
            min-width="230"
            sortable
            v-slot="{ row }"
          >
            {{ row.human__category }}
          </el-table-column>

          <el-table-column
            label="Percentual de participação"
            prop="percentage_partipation"
            min-width="230"
            sortable
            v-slot="{ row }"
          >
            {{ (row.percentage_partipation || 0).toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }} %
          </el-table-column>

          <el-table-column
            label="Rebate"
            prop="percentage_partipation"
            min-width="230"
            sortable
            v-slot="{ row }"
          >
            {{ (row.rebate || 0).toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }} %
          </el-table-column>

          <el-table-column
            label="Período"
            prop="period"
            min-width="230"
            sortable
            v-slot="{ row }"
          >
            {{ row.period }}
          </el-table-column>

          <el-table-column label="Ações" min-width="100" v-slot="{ row }">
            <div class="row">
              <el-dropdown
                trigger="hover"
                class="dropdown"
                style="cursor: pointer"
              >
                <span class="btn btn-sm btn-icon-only text-success">
                  <i class="fas fa-ellipsis-v mt-2"></i>
                </span>
                <el-dropdown-menu
                  class="dropdown-menu dropdown-menu-arrow show"
                  slot="dropdown"
                >
                  <a class="dropdown-item" href="#" @click="edit(row)"
                    >Editar</a
                  >
                  <a class="dropdown-item" href="#" @click="remove(row)"
                    >Excluir</a
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Modal from "@/components/Modal";
import PageTitle from "@/layouts/PageTitle";
import { required } from "vee-validate/dist/rules";
import { ValidationProvider, extend } from "vee-validate";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";


import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";

extend("required", {
  ...required,
  message: "Este campo é obrigatório",
});

export default {
  name: "app",
  components: {
    PageTitle,
    Modal,
    Multiselect,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  data() {
    return {
      filter: {
        category: null,
      },
      modal0: false,
      modal1: false,
      cargoSelected: null,
      cargo: ["Vendedor", "Gerente Comercial"],
      participation: [],
      partSelected: "",
      percentualEdit: null,
      cargoSearch: "",
      partSearch: "",
      metas: {},
      gerente: null,
      percentual: null,
      planoMeta: false,
      rebateValue: null,
      isLoading: false,
      checkbox: null,
      metasBayer: [],
      errors: [],
    };
  },
  mounted() {
    this.getParticipation();
    this.getMetasBayer();
  },
  methods: {
    getMetasBayer() {
      this.isLoading = true;
      this.$http.secured
        .get(`/api/v1/metas_bayer`, {})
        .then((response) => {
          this.metasBayer = response.data;
          this.isLoading = false;
        })
        .catch((error) => this.setError(error, "Something went wrong"));
    },
    metaBayerCem() {
      this.planoMeta = true;
    },
    search() {
      let category;
      if (this.filter.category == "Gerente Comercial") {
        category = "manager";
      } else if (this.filter.category == "Coordenador") {
        category = "coordinator";
      } else if (this.filter.category == "Vendedor") {
        category = "salesman";
      }

      this.$http.secured
        .get("/api/v1/metas_bayer", {
          params: {
            "metas_bayer[category]": category ? category : null,
            "metas_bayer[period]": this.partSearch
              ? this.partSearch.descricao
              : null,
          },
        })
        .then((response) => {
          this.metasBayer = response.data;
        })
        .catch((error) => this.setError(error, "Something went wrong"));
    },
    save() {
      if (this.cargoSelected == "Gerente Comercial") {
        this.cargoSelected = 0;
      } else if (this.cargoSelected == "Coordenador") {
        this.cargoSelected = 1;
      } else if (this.cargoSelected == "Vendedor") {
        this.cargoSelected = 2;
      }
      if (
        this.checkbox == true &&
        this.percentual != null &&
        this.cargoSelected != null &&
        this.partSelected != "" &&
        this.rebateValue != null
      ) {
        this.$http.secured
          .post(`/api/v1/metas_bayer`, {
            percentage_partipation: this.percentual,
            period: this.partSelected.descricao,
            participation_ppr_id: this.partSelected.id,
            category: this.cargoSelected,
            rebate: this.rebateValue,
          })
          .then((response) => {
            this.getMetasBayer();
            this.limpCampos();
            this.modal0 = false;
          })
          .catch((error) => {
            this.errors = error.response.data.errors
            console.log(this.errors)
          });
      }
    },
    limpCampos() {
      this.cargoSelected = null;
      this.percentual = null;
      this.checkbox = false;
      this.partSelected = "";
      this.rebateValue = null;
    },
    edit(metas) {
      this.metas = metas;
      this.modal1 = true;
    },
    editMetas() {
      this.$http.secured
        .put(`/api/v1/metas_bayer/${this.metas.id}`, this.metas)
        .then((response) => {
          this.getMetasBayer();
        })
        .catch((error) => this.setError(error, "Something went wrong"));
      this.modal1 = false;
    },
    remove(metas) {
      if (
        confirm(
          "Deseja excluir as metas bayer " + `${metas.human__category}` + "?"
        )
      ) {
        this.$http.secured
          .delete(`/api/v1/metas_bayer/${metas.id}`, metas)
          .then((response) => {
            this.getMetasBayer();
          })
          .catch((error) => this.setError(error, "Cannot delete meta bayer"));
      }
    },
    getParticipation() {
      this.$http.secured
        .get(`/api/v1/admin/participation_pprs`, { params: { unpaged: true } })
        .then((response) => {
          this.participation = response.data;
        })
        .catch((error) => this.setError(error, "Something went wrong"));
    },
    clearFilters() {
      this.filter.category = null,
      this.partSearch = ""
    },
  },
  computed: {},
};
</script>

<style>
.tableStyle {
  margin-top: 3%;
}
.title {
  margin-bottom: 2%;
}
.el-table__row {
  background-color: white;
  text-align: center;
}
.checkboxtext {
  font-size: 100px;
  display: inline;
  zoom: 1.5;
  margin-top: 2;
}
.labelCheck {
  margin-left: 5px;
}
.multiselect__select {
  height: 44px;
}
</style>
